import { Route } from '@angular/router';

export const arnRoutes: Route[] = [];
